/** @typedef {'light' | 'dark' | 'default' | 'transparent'} InputTheme */

/** @type {InputTheme[]} */
export const availableInputThemes = ['light', 'dark', 'default', 'transparent'];

